export default "__VITE_ASSET__eAFp3Nn5__"